module.exports = __webpack_public_path__ + "static/media/image-intro-mobile.09a91c1a.jpg";